import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface SplitLayoutProps {
  children: React.ReactNode;
  imageSrc?: string;
  logoSrc?: string;
}
export function SplitLayout({
  children,
  imageSrc = 'https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?q=80&w=2000&auto=format&fit=crop',
  logoSrc = 'https://cdn.magicpatterns.com/uploads/jf93DJKVVHMQcEr8jhkoLt/maybank-logo-png-transparent.png'
}: SplitLayoutProps) {
  return <div className="flex min-h-screen w-full bg-white overflow-hidden" data-id="element-483">
      {/* Left Content Side */}
      <div className="w-full lg:w-1/2 flex flex-col h-screen overflow-y-auto" data-id="element-484">
        <div className="flex-1 flex flex-col px-6 py-12 sm:px-12 lg:px-16 xl:px-24 max-w-2xl mx-auto w-full" data-id="element-485">
          {/* Logo */}
          <div className="mb-12" data-id="element-486">
            <img src={logoSrc} alt="Maybank" className="h-10 w-auto object-contain" data-id="element-487" />
          </div>

          {/* Main Content Area */}
          <div className="flex-1 flex flex-col justify-center" data-id="element-488">
            <AnimatePresence mode="wait" data-id="element-489">
              <motion.div initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -10
            }} transition={{
              duration: 0.3
            }} className="w-full" data-id="element-490">
                {children}
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Footer */}
          <div className="mt-12 text-xs text-gray-400" data-id="element-491">
            <p data-id="element-492">
              &copy; {new Date().getFullYear()} Maybank. All rights reserved.
            </p>
          </div>
        </div>
      </div>

      {/* Right Image Side */}
      <div className="hidden lg:block lg:w-1/2 relative bg-gray-900" data-id="element-493">
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent z-10" data-id="element-494" />
        <img src={imageSrc} alt="Business owner managing operations" className="absolute inset-0 h-full w-full object-cover" data-id="element-495" />
        <div className="absolute bottom-0 left-0 right-0 p-12 z-20 text-white" data-id="element-496">
          <blockquote className="max-w-lg" data-id="element-497">
            <p className="text-xl font-medium mb-4" data-id="element-498">
              "Maybank has been instrumental in growing our e-commerce business
              across Malaysia. Their digital banking platform is truly
              world-class."
            </p>
            <footer className="flex items-center space-x-4" data-id="element-499">
              <div className="h-10 w-10 rounded-full bg-white/20 flex items-center justify-center font-bold text-sm" data-id="element-500">
                LT
              </div>
              <div data-id="element-501">
                <div className="font-semibold" data-id="element-502">Lee Tan</div>
                <div className="text-white/70 text-sm" data-id="element-503">
                  CEO, TechMart Sdn Bhd
                </div>
              </div>
            </footer>
          </blockquote>
        </div>
      </div>
    </div>;
}